// extracted by mini-css-extract-plugin
export default {"container":"DB-z","dimension":"EB-z","dimensionLabels":"FB-z"};